/**
 * 全部
 * 未结算
 * 已结算
 */
export enum SettleStatusEnum {
  ALL,
  UN_SETTLEMENT,
  SETTLED
}

/**
 * account 账户
 * current 分页
 * gameCategoryId 游戏分类id
 * gameIds 游戏id
 * platformId 平台id
 * settle Time Start 起始时间戳
 * settle Time End 结束时间戳
 * size 分页大小
 * xTimestamp 当前时间戳
 */
export interface CenterGetBettingRecordListPayload {
  account: number
  current?: number
  gameCategoryId?: number
  gameIds?: number
  platformId?: number
  settleTimeEnd?: number
  settleTimeStart?: number
  settleStatus?: number
  size?: number
}

/**
 * 投注记录接口响应数据
 */
export interface BettingRecordData {
  allBet: number
  gameCategoryName: string
  gameName: string
  netProfit: number
  platformName: string
  recordId: string
  settleStatus: number
  settleTime: number
  validBet: number
  winAmount: number
}

/* ----------------------------------------------------------------------- */
/**
 * 中心页面游戏类型筛选条件枚举接口入参
 */
export type CenterGetCategoryComboPayload = {
  gameCategoryId?: number | null
  platformId?: number | null
}

/**
 * 中心页面枚举接口响应数据
 */

export interface CategoryComboData {
  category?: BaseCategory[]
  gameList?: GameCategory[]
  platform?: PlatformCategory[]
}

/**
 * 游戏类型
 */
export interface BaseCategory {
  categoryId: number
  categoryName: string
}

/**
 * 平台类型
 */
export interface PlatformCategory {
  platformId: number
  platformName: string
}

/**
 * 游戏具体内容
 */
export interface GameCategory {
  gameId: number
  gameName: string
}

/* ----------------------------------------------------------------------- */

/**
 * 账户类型接口响应数据
 */
export interface AccountTypeListData {
  opt_type_list: Array<AccountTypeCategory>
}

/**
 * 账户类型
 */
export interface AccountTypeCategory {
  id: number
  name: string
}

/* ----------------------------------------------------------------------- */
/**
 * 账户明细列表接口响应数据
 */

export interface AccountDetailsListPayload {
  page?: string
  time: string
  type: string
  size?: string
  dealType?: string
}

export interface AccountDetailsData {
  /**
   * 时间戳
   */
  finish_game_time: number
  /**
   * 变更金额
   */
  item_count: number
  /**
   * 当前余额
   */
  cur_count: number
  /**
   * 账变小类名称（老版本保留，请使用deal_type_name）
   */
  opt_type_text: string
  /**
   * 备注
   */
  remark: string
  /**
   * 账变大类（新增）
   */
  opt_type: number
  /**
   * 账变大类名称（新增）
   */
  opt_type_name: string
  /**
   * 账变小类（新增）
   */
  deal_type: number
  /**
   *  账变小类名称（新增）
   */
  deal_type_name: string
  /**
   *  后端接口返回值无唯一值，添加index给vue组件key使用
   */
  key: string
}

/**----------------------------------------------------------------------- */

/**
 * 账户统计查询入参
 */

export interface AccountTotalPayload {
  time: string
  cate_id?: string
  platform_id?: string
  type?: string
  dealType?: string
}

/**
 * 账户统计响应数据
 */

export interface AccountTotalData {
  /**
   * 充值
   */
  total_charge_amount: number
  /**
   *  提现
   */
  total_withdraw_amount: number
  /**
   * 任务总额
   */
  total_task_amount: number
  /**
   * 余额宝总额
   */
  total_yuebao_amount: number
  /**
   * 优惠总额
   */
  total_discount_amount: number
  /**
   * 返水总额
   */
  total_returngold_amount: number
  /**
   * 活动总额
   */
  total_event_amount: number
  /**
   *  有效投注总额
   */
  total_valid_bet: number
  /**
   * 盈利总额
   */
  total_item_count: number
  /**
   *  派彩总额
   */
  total_settle: number
  /**
   *  用户余额
   */
  balance: number
  /**
   *  总注单量
   */
  betitemNum: number
}

/**----------------------------------------------------------------------- */
/**
 * 个人报表列表接口入参
 */
export interface PersonalStatementListPayload {
  account: number
  current?: number
  gameCategoryId?: number
  platformId?: number
  settleTimeEnd?: number
  settleTimeStart?: number
  endDate?: number
  startDate?: number
  size?: number
}

// 非分页
export interface PersonalStatementListV1Payload {
  account: string
  gameCategoryId?: number
  platformId?: number
  settleTimeEnd?: number
  settleTimeStart?: number
  endDate?: number
  startDate?: number
}
/**
 * 个人报表列表接口数据
 */

export interface PersonalStatementListData {
  allBet: number
  date: string
  dateTimestamp: number
  gameCategoryName: string
  gameName: string
  netProfit: number
  platformName: string
  validBet: number
  betitemNum: number
  winAmount: number
}

/**----------------------------------------------------------------------- */
/**
 * 账户类型细项
 */
export interface AccountDealTypePayload {
  optTypes: number[]
}
export interface AccountDealTypeListData {
  status: {
    msg: string
  }
  optTypeMap?: {
    [key: string]: {
      optType: string
      dealTypeInfos: Array<AccountDealTypeCategory>
    }
  }
}

export interface AccountDealTypeCategory {
  dealType: number
  dealTypeCn: string
}
